import Icon from '../components/Icon.vue'

Icon.register({
  'sync-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M370.7 133.3c-31.3-29.3-71.8-45.3-114.9-45.3-77.5 0.1-144.3 53.2-162.8 126.8-1.3 5.4-6.1 9.2-11.7 9.2h-57.3c-7.5 0-13.2-6.8-11.8-14.2 21.6-114.9 122.5-201.8 243.7-201.8 66.4 0 126.8 26.1 171.3 68.7l35.7-35.7c15.1-15.1 41-4.4 41 17v134.1c0 13.3-10.7 24-24 24h-134.1c-21.4 0-32.1-25.9-17-41zM32 296h134.1c21.4 0 32.1 25.9 17 41l-41.8 41.8c31.3 29.3 71.8 45.3 114.9 45.3 77.4-0.1 144.3-53.1 162.8-126.8 1.3-5.4 6.1-9.2 11.7-9.2h57.3c7.5 0 13.2 6.8 11.8 14.2-21.6 114.9-122.5 201.8-243.7 201.8-66.4 0-126.8-26.1-171.3-68.7l-35.7 35.7c-15.1 15.1-41 4.4-41-17v-134.1c0-13.3 10.7-24 24-24z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sync-alt.js
// module id = 1972
// module chunks = 0